import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import * as CryptoJS from 'crypto-js';
import { TenantService } from 'src/app/services/api/tenant.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { PermissionValues } from 'src/app/models/permission-values';
import { PermissionService } from 'src/app/services/api/permission.service';
import * as permissionsData from 'src/app/models/permissions.json';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    selector: 'app-tenant-my-account',
    templateUrl: './tenant-my-account.component.html',
    styleUrls: ['./tenant-my-account.component.scss'],
    standalone: false
})
export class TenantMyAccountComponent  implements OnInit  {
private destroyRef = inject(DestroyRef);
  Constants = Constants;
  userInfo: any;
  refreshRotate = false;
  token: any;
  encryptedBase64Key: string = "ZmFicmljc2VjcmV0a2V5cw==";
  tenants: any;
  selectedTenant: string;
  showLoader = false;
  assignedPermissions: any;
  permissionsData: any;
  initialPermissionData: any;
  selectedPermission: any;
  dropdownSearchValue: string;
  initialTenants: any;

  constructor(public authService: AuthService, private toastrService: CustomToastrService, private tenantService: TenantService,
    private permissionsService: PermissionService
  ) {
    
  }

  ngOnInit(): void {
    this.userInfo = this.authService.principal;
    if (this.userInfo?.code) {
      this.decryptToken(this.userInfo?.code);
    }
    this.getTenants();
  }

  refreshClick(): void {
    this.refreshRotate = true;
    setTimeout(() => {
      this.refreshRotate = false;
    }, 1000);
    this.authService.loadRefresh().subscribe(data => {
      this.userInfo = data;
      if (this.userInfo?.code) {
        this.decryptToken(this.userInfo?.code);
      }
    });
    
  }

  decryptToken(token): void {
    const parsedBase64Key = CryptoJS.enc.Base64.parse(this.encryptedBase64Key);
    const encryptedCipherText = token;
    const decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    this.token =  decryptedData.toString(CryptoJS.enc.Utf8);
  }

  onCopy(): void {
    this.toastrService.clear();
    this.toastrService.checkboxMessage('Token Copied')
  }

  getTenants(): void {
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.tenants = data;
          this.initialTenants = this.tenants;
        }
      },
      (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  tenantChanged(tenant): void {
    this.showLoader = true;
    this.selectedTenant = tenant;
    const scope = PermissionValues.TENANT + this.selectedTenant;
    this.permissionsService.getAuthAssignedPermissions(scope)
    .pipe().subscribe(response => {
      this.showLoader = false;
      const permissions = permissionsData;
      this.initialPermissionData = permissions.permissionsData;
      // view profile - removed audit, access control tabs.
      this.initialPermissionData = this.initialPermissionData.filter(item => item.key !=='authz' && item.key !=='audit');
      this.permissionsData = cloneDeep(this.initialPermissionData);
      this.selectedPermission = this.permissionsData.find(item => item?.isSelected === true);
      this.assignedPermissions = response.permissions;
      this.assignedPermissions?.forEach(permission =>  {
        const actions = [permission.action];
        if (permission.action.startsWith('/')) {
          actions.push(permission.action.substring(1)); 
        } else {
          actions.push('/' + permission.action); 
        }
        actions.forEach(action => {
        let row;
        let tab = action.split('/')[1];
        if(action.includes("jumpbox")){
          tab = action.split('/')[2];
        } else if(action.includes("pe-connections")) {
          tab = action.split('/')[2];
        } else if(action.includes("runbook")) {
          tab = action.split('/')[2];
        } else if(action.includes("schedules")) {
          tab = action.split('/')[2];
        } else if(action.includes("jobs")) {
          tab = action.split('/')[2];
        } 
       if (action.split('/').length === 3 || tab === 'authz') {
          row = action.split('/')[2];
        }
        else {
          row = action.split('/')[2] + '/' + action.split('/')[3];
        }

        if (this.permissionsData.find(item => item.key === tab) && this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row) && 
          !this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions) {
          this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row).access = true;
        }
        if (this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions) {
          if (permission.attribute === 'datazone') {
            const permissionItem = this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions
                                   .find(item => item.key === permission.attributeValue);
            if (permissionItem && permissionItem.access !== undefined) {
                permissionItem.access = true;
            }     
                      
          } else if (permission.attribute === 'type') {
            this.permissionsData.find(item => item.key === tab).permissions.find(item => item.key === row)
              .dataZonePermissions.map(item => item.infoDetails = [...item.infoDetails, permission.attributeValue]);
          } else {
            if (tab === 'authz') {
              const permissionItem = this.permissionsData.find(item => item.key === tab)?.permissions.find(item => item.key === row)?.dataZonePermissions
              .find(item => item.key === permission.action.split('/')[3]);
              if (permissionItem && permissionItem.access !== undefined) {
                permissionItem.access = true;
              }  
            }
          }
        }
      });
    })
    },
    (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  dataZonePermissions(permissions): boolean {
    return permissions?.some(item => item.dataZonePermissions);
  }

  selectPermission(permission): void {
    this.selectedPermission = permission;
    this.permissionsData.map(item => item.isSelected = false);
    this.permissionsData.find(item => item.key === permission.key).isSelected = true;
  }

  resetDropdown() {
    setTimeout(() => {
    this.dropdownSearchValue = '';
    this.tenants = [...this.initialTenants];
    }, 100);
  }

  searchChanged(value): void {
    this.tenants = this.initialTenants?.filter(item => item?.tenantId?.toLowerCase().startsWith(value.toLowerCase()));
  }
}
